import { TWizardStepComponentStatic } from "../../../interfaces";
import React, { forwardRef } from "react";
import { WizardStepIntroductionView } from "../../../Host/Steps/WizardStepIntroduction";

export const WizardStepWelcomePublish: TWizardStepComponentStatic<any> =
  forwardRef(() => {
    return <WizardStepIntroductionView activeStep="publish" />;
  });
